import { Component } from '@angular/core';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@Component({
    selector: 'app-notifications-sidebar',
    templateUrl: './notifications-sidebar.component.html',
    styleUrls: ['./notifications-sidebar.component.scss'],
    standalone: true,
    imports: [FontAwesomeModule],
})
export class NotificationsSidebarComponent {
    constructor() {}
}
